export default {"src":"/_next/static/media/home-ok-hand.b17a076a.svg","height":247,"width":217,"blurWidth":0,"blurHeight":0};